module.exports = __webpack_public_path__ + "media/images/info-icon-5f138906c67493a1ae6ffeaa109dcfc3.jpg";